import React from 'react'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import { Typography } from '@mui/material'

export default function Header() {
    const itemTitles = {
        productID: 'Item Code',
        descriptionTitle: 'Description',
        pkgQty: 'Qty/Pack',
        sugRetail: 'Price',
        itemQty: 'Quantity',
        lineItemTotal: 'SubTotal',
    }

    const itemWidth = {
        productID: 3,
        descriptionTitle: 7,
        pkgQty: 3,
        sugRetail: 2,
        itemQty: 3,
        lineItemTotal: 2,
    }
    const itemAlignment = {
        productID: 'left',
        descriptionTitle: 'left',
        pkgQty: 'center',
        sugRetail: 'left',
        itemQty: 'left',
        lineItemTotal: 'right',
    }

    const itemSX = {
        productID: { pl: 1.5 },
        descriptionTitle: { pl: { xs: 12, md: 9 } },
        pkgQty: { pl: 1 },
        sugRetail: { pl: { md: 1, lg: 5 } },
        itemQty: { pl: { md: 2, lg: 7 } },
        lineItemTotal: { pr: 1 },
    }

    const headerRow = Object.keys(itemTitles).map((title) => {
        return (
            <Grid2
                key={title}
                md={itemWidth[title]}
                sx={{
                    textAlign: itemAlignment[title],
                }}
            >
                <Typography sx={itemSX[title]} variant="h6">
                    {itemTitles[title]}
                </Typography>
            </Grid2>
        )
    })

    return (
        <Grid2
            container
            columns={20}
            sx={{
                border: 1,
                borderColor: 'black',
                borderBottom: 2,
                borderBottomColor: 'black',
            }}
        >
            {headerRow}
        </Grid2>
    )
}
